import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import { Card, CardContent } from '../ui/card';

const SuperadminApiUsageChart = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/superadmin-stats/api-usage`, { withCredentials: true })
      .then(res => {
        const formatted = res.data.map(entry => ({
          day: entry.day,
          requests: parseInt(entry.requests, 10)
        }));
        setData(formatted);
      })
      .catch(err => console.error('Fehler beim Laden der API-Auslastung:', err));
  }, []);

  return (
    <Card className="rounded-2xl shadow-md p-4">
      <CardContent>
        <h2 className="text-lg font-semibold mb-2">API-Auslastung (7 Tage)</h2>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="day" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line type="monotone" dataKey="requests" stroke="#2563eb" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default SuperadminApiUsageChart;
